module.exports = __webpack_public_path__ + "static/media/people.06f49649.svg";